/**
 * MSRP price = plain set price + every option line.
 * Logo, text, upload, color, fill, and bolt dollars are the line prices.
 * productsState.activeObj.base_price is the plain set from fitment load.
 * A parent-supplied base_price is not used.
 *
 * price_min is the company catalog's lowest variant, already the discounted
 * plain-set price. The discount percentage is the percent off that MSRP.
 * Discounted price = MSRP price × (1 - discount percentage / 100).
 *
 * Pass returnMsrpPrice to get the MSRP price. The Shopify variant is created
 * at that MSRP price so the company catalog applies the discount once.
 */

import { basePriceForFitment } from "./mgpBasePrice";

const MIN_DISCOUNT_RATIO = 0.01;

export const getFinalPrice = (productsState, cartData, returnMsrpPrice = false) => {
  const product = productsState?.activeObj || {};
  let msrpPrice = basePriceForFitment(product);

  (cartData || []).forEach((item) => {
    if (!item || !isNumber(item.price)) return;
    msrpPrice += item.price;
  });

  const percentage = discountPercentage(product);
  if (!returnMsrpPrice && percentage) {
    console.log(`[getFinalPrice] discount percentage ${percentage}%`);
    return (msrpPrice * (1 - percentage / 100)).toFixed(2);
  }

  return msrpPrice.toFixed(2);
};

// An option's MSRP price, or that price after the discount percentage.
export function discountedPrice(msrpPrice, product) {
  const n = Number(msrpPrice);
  if (!Number.isFinite(n)) return msrpPrice;
  const percentage = discountPercentage(product);
  if (!percentage) return n;
  return (n * (1 - percentage / 100)).toFixed(2);
}

// Percent off MSRP for a dealer, such as 20. Null when this is not a dealer.
// Zero when the catalog price is not a real discount off MSRP.
export function discountPercentage(product) {
  if (!product?.isDealer) return null;
  const priceMin = Number(product.price_min);
  const msrpPrice = basePriceForFitment(product);
  if (!msrpPrice || !Number.isFinite(priceMin) || priceMin <= 0) return null;
  if ((msrpPrice - priceMin) / msrpPrice <= MIN_DISCOUNT_RATIO) return 0;
  return Number(((1 - priceMin / msrpPrice) * 100).toFixed(2));
}

// Hidden cart property _msrp. The value is the MSRP price.
export function msrpPriceProperty(product, msrpPrice) {
  if (!product?.isDealer) return null;
  if (!Number.isFinite(Number(product.price_min))) {
    console.warn("dealer session but no price_min; skipping _msrp");
    return null;
  }
  const n = Number(msrpPrice);
  if (!Number.isFinite(n)) return null;
  return n.toFixed(2);
}

function isNumber(num) {
  return typeof num === "number" && !isNaN(num);
}
